export default "__VITE_ASSET__Pd0KcDvM__"